import { z } from 'zod';

const optionalEmptyString = z.string().trim().optional().or(z.literal(''));

export const tagSettingsSchema = z.object({
  site_id: z.string(),
  gtmId: optionalEmptyString.refine(
    (value) => !value || /^GTM-[A-Z0-9]+$/u.test(value),
    'GTM ID は GTM-XXXX の形式で入力してください。',
  ),
  ga4Id: optionalEmptyString.refine(
    (value) => !value || /^G-[A-Z0-9]+$/u.test(value),
    'GA4 ID は G-XXXX の形式で入力してください。',
  ),
  metaPixelId: optionalEmptyString.refine(
    (value) => !value || /^[0-9]+$/u.test(value),
    'Meta Pixel ID は数字のみで入力してください。',
  ),
  updated_at: z.string().optional(),
});

export type TagSettings = z.infer<typeof tagSettingsSchema>;

export const updateTagSettingsInputSchema = z.object({
  gtmId: tagSettingsSchema.shape.gtmId,
  ga4Id: tagSettingsSchema.shape.ga4Id,
  metaPixelId: tagSettingsSchema.shape.metaPixelId,
});

export type UpdateTagSettingsInput = z.infer<typeof updateTagSettingsInputSchema>;
